module.exports = __webpack_public_path__ + "static/team-6-5bb700d4514adcc23a7532501b89a67c.png";